/**
 * @deprecated In attesa di ristrutturazione con API v2
 */
export const useActivateCollaborator = () => {
  // TODO: Implementare con nuovo endpoint
  return {
    mutateAsync: async () => {
      console.warn("useActivateCollaborator è deprecato");
    },
  };
};
